module.exports = __webpack_public_path__ + "static/media/auto_icon_bb.19076609.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/auto_icon_bb.svg
// module id = 1210
// module chunks = 0